import { Sistema, TipoOrgano, Organo, Puesto, Rol, Municipio } from '../types/catalogs';

export const MOCK_SISTEMAS: Sistema[] = [
  {
    id_sistema: 1,
    nombre: 'Sistema de Nómina',
    nombre_corto: 'NOMINA',
    ruta: '/nomina',
    solo_activo_proceso: false,
    estatus: true,
  },
  {
    id_sistema: 2,
    nombre: 'Sistema de Inventarios',
    nombre_corto: 'INVENTARIOS',
    ruta: '/inventarios',
    solo_activo_proceso: false,
    estatus: true,
  },
  {
    id_sistema: 3,
    nombre: 'Sistema de Recursos Humanos',
    nombre_corto: 'RRHH',
    ruta: '/rrhh',
    solo_activo_proceso: true,
    estatus: true,
  },
  {
    id_sistema: 4,
    nombre: 'Gestión Documental',
    nombre_corto: 'DOCS',
    ruta: '/documentos',
    solo_activo_proceso: false,
    estatus: true,
  },
  {
    id_sistema: 5,
    nombre: 'Control de Usuarios',
    nombre_corto: 'USUARIOS',
    ruta: '/usuarios',
    solo_activo_proceso: false,
    estatus: true,
  },
];

export const MOCK_TIPOS_ORGANO: TipoOrgano[] = [
  { id_tipo_organo: 1, nombre: 'Dependencia', estatus: true },
  { id_tipo_organo: 2, nombre: 'Entidad', estatus: true },
  { id_tipo_organo: 3, nombre: 'Órgano Autónomo', estatus: true },
  { id_tipo_organo: 4, nombre: 'Municipio', estatus: true },
  { id_tipo_organo: 5, nombre: 'Poder Judicial', estatus: false },
];

export const MOCK_ORGANOS: Organo[] = [
  {
    id_organo: 1,
    nombre: 'Órgano Central',
    siglas: 'OC',
    id_tipo_organo: 1,
    estatus: true,
  },
  {
    id_organo: 2,
    nombre: 'Órgano Norte',
    siglas: 'ON',
    id_tipo_organo: 2,
    estatus: true,
  },
  {
    id_organo: 3,
    nombre: 'Órgano Sur',
    siglas: 'OS',
    id_tipo_organo: 1,
    estatus: true,
  },
  {
    id_organo: 4,
    nombre: 'Órgano Este',
    siglas: 'OE',
    id_tipo_organo: 3,
    estatus: true,
  },
  {
    id_organo: 5,
    nombre: 'Órgano Oeste',
    siglas: 'OO',
    id_tipo_organo: 2,
    estatus: true,
  },
];

export const MOCK_PUESTOS: Puesto[] = [
  {
    id_puesto: 1,
    nombre: 'Director General',
    alias_sap: 'DIR_GEN',
    estatus: true,
  },
  { id_puesto: 2, nombre: 'Subdirector', alias_sap: 'SUB_DIR', estatus: true },
  {
    id_puesto: 3,
    nombre: 'Jefe de Departamento',
    alias_sap: 'JEFE_DEPT',
    estatus: true,
  },
  { id_puesto: 4, nombre: 'Analista', alias_sap: 'ANALISTA', estatus: true },
  {
    id_puesto: 5,
    nombre: 'Auxiliar Administrativo',
    alias_sap: 'AUX_ADM',
    estatus: true,
  },
];

export const MOCK_ROLES: Rol[] = [
  {
    id_rol: 1,
    nombre: 'Administrador',
    descripcion: 'Acceso total al sistema',
    estatus: true,
  },
  {
    id_rol: 2,
    nombre: 'Secretaría Ejecutiva',
    descripcion: 'Personal de la Secretaría Ejecutiva',
    estatus: true,
  },
  {
    id_rol: 3,
    nombre: 'Empleado',
    descripcion: 'Personal operativo general',
    estatus: true,
  },
  {
    id_rol: 4,
    nombre: 'Consulta',
    descripcion: 'Acceso de solo lectura',
    estatus: true,
  },
];

export const MOCK_MUNICIPIOS: Municipio[] = [
  { id_municipio: 1, nombre: 'Guanajuato', siglas: 'GTO', estatus: true },
  { id_municipio: 2, nombre: 'León', siglas: 'LEO', estatus: true },
  { id_municipio: 3, nombre: 'Irapuato', siglas: 'IRA', estatus: true },
  { id_municipio: 4, nombre: 'Celaya', siglas: 'CEL', estatus: true },
  { id_municipio: 5, nombre: 'Salamanca', siglas: 'SAL', estatus: true },
];
